var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsedAsSpecificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.335484 0H19.4839H19.8194V0.335484V11.4968V11.8323H19.4839H12.5113V13.1694H13.6855V14H6.10968V13.1694H7.28387V11.8323H0.335484H0V11.4968V0.335484V0H0.335484ZM19.15 0.669355H0.669355V11.1613H19.1484L19.15 0.669355Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsedAsSpecificationIcon);
export default __webpack_public_path__ + "static/media/used_as_specification_icon.5b2f4c45fea9bcf627ac4e9bfa420f2d.svg";
export { ForwardRef as ReactComponent };